import { normalizeConstants, getDefaultConstants } from './priceSimulateCompute';
import { getWorkspaceMetadata, updateWorkspaceMetadata } from '../../app/workspaceMetadata';

export const STORAGE_KEY = 'eagle_price_simulate_constants_v1';
export const PRICE_SIMULATE_METADATA_KEY = 'price_simulate.constants_v1';

function nf(v) {
  const n = typeof v === 'number' ? v : parseFloat(v);
  return Number.isFinite(n) ? n : 0;
}

function pickMaterials(defaultsMaterials, storedMaterials) {
  if (!storedMaterials || typeof storedMaterials !== 'object' || Array.isArray(storedMaterials)) {
    return { ...defaultsMaterials };
  }
  const cleaned = {};
  for (const [k, v] of Object.entries(storedMaterials)) {
    const name = String(k).trim();
    if (!name || !v || typeof v !== 'object') continue;
    cleaned[name] = { cost_per_kg: nf(v.cost_per_kg) };
  }
  return Object.keys(cleaned).length > 0 ? cleaned : { ...defaultsMaterials };
}

export function loadStoredRawLocal() {
  try {
    const s = localStorage.getItem(STORAGE_KEY);
    if (!s) return null;
    const parsed = JSON.parse(s);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function mergeStoredRawIntoConstants(stored) {
  const defaults = getDefaultConstants();
  if (!stored) return defaults;
  return normalizeConstants({
    materials: pickMaterials(defaults.materials, stored.materials),
    machine: { ...defaults.machine, ...(stored.machine || {}) },
    services: { ...defaults.services, ...(stored.services || {}) },
    percentages: { ...defaults.percentages, ...(stored.percentages || {}) },
    pricing: { ...defaults.pricing, ...(stored.pricing || {}) },
    work: stored.work,
  });
}

export function loadInitialConstants() {
  return mergeStoredRawIntoConstants(loadStoredRawLocal());
}

export function persistConstantsLocal(constants) {
  const payload = JSON.parse(JSON.stringify(constants));
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
}

export function persistConstants(constants) {
  persistConstantsLocal(constants);
}

export async function loadConstantsFromWorkspace(workspaceId) {
  const res = await getWorkspaceMetadata(workspaceId);
  const str = res.data?.metadata?.[PRICE_SIMULATE_METADATA_KEY];
  if (str == null || typeof str !== 'string' || !str.trim()) {
    return null;
  }
  let parsed;
  try {
    parsed = JSON.parse(str);
  } catch {
    return null;
  }
  if (!parsed || typeof parsed !== 'object') return null;
  return mergeStoredRawIntoConstants(parsed);
}

export async function saveConstantsToWorkspace(workspaceId, constants) {
  const payload = JSON.parse(JSON.stringify(constants));
  await updateWorkspaceMetadata(workspaceId, {
    [PRICE_SIMULATE_METADATA_KEY]: JSON.stringify(payload),
  });
}
